import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/scroll";

const WORKS = [
  {
    img: "/images/faux-plafond-chantier-en-cours-77.png",
    alt: "Faux plafond en cours de réalisation — ossature et plaques, chantier LIMEN en Seine-et-Marne",
    title: "Faux plafond",
    status: "Chantier en cours",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    img: "/images/cloison-ossature-metallique-chantier.png",
    alt: "Cloison sur ossature métallique en cours de montage — plaquiste Seine-et-Marne",
    title: "Cloison sur ossature",
    status: "Chantier en cours",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    img: "/images/doublage-isolant-mise-en-oeuvre.png",
    alt: "Doublage isolant en mise en œuvre — isolation intérieure Seine-et-Marne",
    title: "Doublage isolant",
    status: "Mise en œuvre",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    img: "/images/corniche-led-finition-renovation.png",
    alt: "Corniche LED en finition — éclairage indirect, rénovation intérieure 77",
    title: "Corniche LED",
    status: "Finition",
    span: "md:col-span-7",
    aspect: "aspect-[16/10]",
  },
  {
    img: "/images/amenagement-tv-niche-led-sur-mesure.png",
    alt: "Aménagement TV sur mesure — niche et corniche LED intégrées par LIMEN",
    title: "Aménagement TV",
    status: "Réalisation sur mesure",
    span: "md:col-span-6",
    aspect: "aspect-[3/2]",
  },
  {
    img: "/images/renovation-interieure-piece-a-vivre.png",
    alt: "Rénovation intérieure terminée — ouvrage livré par LIMEN en Seine-et-Marne",
    title: "Rénovation intérieure",
    status: "Ouvrage terminé",
    span: "md:col-span-6",
    aspect: "aspect-[3/2]",
  },
];

export const Realisations = () => (
  <section id="realisations" data-testid="realisations-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        chapter="03 — Réalisations"
        title="Nos réalisations"
        subtitle="Le chantier se juge autant pendant son exécution qu’à sa livraison."
        testId="realisations"
      />
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10">
        {WORKS.map((w, i) => (
          <Reveal key={w.title} className={w.span} delay={(i % 2) * 0.1}>
            <figure data-testid={`realisation-${i + 1}`} className="group">
              <div className={`relative overflow-hidden ${w.aspect}`}>
                <img
                  src={w.img}
                  alt={w.alt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
              </div>
              <figcaption className="mt-4 flex items-baseline justify-between gap-4">
                <span className="font-accent text-sm font-medium text-nuit">{w.title}</span>
                <span className="font-accent text-[11px] tracking-[0.2em] uppercase text-sable-deep">{w.status}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-16 text-center" delay={0.1}>
        <button
          data-testid="realisations-cta"
          onClick={() => scrollToId("#contact")}
          className="border border-nuit/25 px-8 py-4 font-accent text-sm font-medium tracking-[0.12em] uppercase text-nuit hover:border-sable-deep hover:text-sable-deep transition-colors duration-300"
        >
          Découvrir nos réalisations
        </button>
      </Reveal>
    </div>
  </section>
);
